export {MatDialog} from '@angular/material/dialog';
export {ActivatedRoute, Router} from '@angular/router';
export {Component, OnInit, AfterViewInit, OnDestroy} from '@angular/core';

export {Subscription} from 'rxjs';

export {
    ApiError,
    ApiResponse,
    ServerResponseData,
    UserStatusesEnum,
    EnrollChannelsEnum,
    ClientStatusesEnum,
    HttpStatusCodesEnum,
    UserRelationTypesEnum,
    TradingGroupStatusesEnum,
    TradingAccountStatusesEnum,
    UsersService,
    TradingService,
    CompaniesService,
    IndividualsService,
    PermissionsService,
    TradingClientInterface,
    LookupModel,
    CountryModel,
    TradingGroupModel,
    TradingClientModel,
    LinkedAccountModel,
    PermissionModel,
    TradingAccountModel,
    CompanyExtendedModel,
    CompanyEmployeeModel,
    IndividualExtendedModel,
    IndividualDocumentModel,
    TradingPlatformInfoModel,
    TradingClientSearchModel,
    OwnerTradingAccountModel,
    UserSendResetPasswordInputModel
} from '@spa/api';

export {Helper} from '../../../../../../shared/classes';
export {PanelPaths} from '../../../../../../shared/paths';
export {DialogActionsEnum} from '../../../../../../shared/components';
export {PermissionRuleInterface} from '../../../../../../shared/interfaces';
export {AlertsService, CacheCollectionService} from '../../../../../../shared/services';
export {InitialComponentDataValidationException} from '../../../../../../shared/exceptions';

export {
    AlertTypesEnum,
    ColumnSizesEnum,
    PermissionsEnum,
    PermissionRuleCheckStrategiesEnum
}from '../../../../../../shared/enums';

export {
    AddBankAccountComponent,
    AddDocumentComponent,
    AddUserToClientComponent,
    DisableAccountsComponent,
    ResetPasswordResultComponent,
    ChangeClientStatusComponent,
    AssignClientAccountRightsComponent
} from '../../../../dialogs';

export {BaseComponent} from '../../../../classes';
export {EventsService} from '../../../../services';
export {LayoutConfigInterface} from '../../../../components';
export {PanelClientsEditTrait, PermissionRulesTrait} from '../../../../traits';

export {
    ClientTypesEnum,
    TradingAccountTypesEnum,
    PanelClientsEditQuickActionsEventsEnum,
    PanelClientsEditResolverErrorStatesEnum
}from '../../../../enums';

export {
    PanelClientsEditResolverDataInterface,
    TradingAccountsReducedObjectInterface,
    AssignAccountRightsSelectableEntityInterface
} from '../../../../interfaces';

export {
    ErrorMessageIdSelector,
    IsCorporateClientSelector,
    AddDocumentDialogConfig,
    AddUserToClientDialogConfig,
    AddBankAccountDialogConfig,
    DisableAccountsDialogConfig,
    ResetPasswordResultDialogConfig,
    ResetPasswordResultDialogTitle,
    ChangeClientStatusDialogConfig
} from '../../../../../../../assets/descriptors';

export {PanelClientsEditMessages} from '../../../../../../../assets/messages';
